import ApprovalService from "./approvalService";
import InternalTransferApprovalType from "../entities/internalTransferApprovalType";
import { bound } from "@frui.ts/helpers";
import InternalTransferResponse from "../entities/internalTransferResponse";

export default class InternalTransferApprovalService extends ApprovalService<
  InternalTransferApprovalType,
  InternalTransferResponse
> {
  @bound
  isApprovalProcessComplete(approvable: InternalTransferResponse) {
    const approvals = approvable.approvals.flatMap(approval => approval.approvalType);

    return (
      approvals.includes(InternalTransferApprovalType.FactualAuditor) &&
      approvals.includes(InternalTransferApprovalType.CommandOperator) &&
      approvals.includes(InternalTransferApprovalType.ChiefAccountant)
    );
  }

  @bound
  currentApproverPredecessor() {
    switch (this.whoAmI()) {
      case InternalTransferApprovalType.ChiefAccountant:
        return InternalTransferApprovalType.CommandOperator;
      case InternalTransferApprovalType.CommandOperator:
        return InternalTransferApprovalType.FactualAuditor;
      case InternalTransferApprovalType.FactualAuditor:
      default:
        return undefined;
    }
  }

  protected isCurrentStepReadyOrDoneForFactualAuditor(approvals: InternalTransferApprovalType[]) {
    return approvals.length === 0 || (approvals.length === 1 && approvals[0] === InternalTransferApprovalType.FactualAuditor);
  }

  protected isCurrentStepReadyOrDoneForCommandOperator(approvals: InternalTransferApprovalType[]) {
    return (
      (approvals.length === 1 && approvals.includes(InternalTransferApprovalType.FactualAuditor)) ||
      (approvals.length === 2 &&
        approvals.includes(InternalTransferApprovalType.FactualAuditor) &&
        approvals.includes(InternalTransferApprovalType.CommandOperator))
    );
  }

  protected isCurrentStepReadyOrDoneForChiefAccountant(approvals: InternalTransferApprovalType[]) {
    return (
      (approvals.length === 2 &&
        approvals.includes(InternalTransferApprovalType.FactualAuditor) &&
        approvals.includes(InternalTransferApprovalType.CommandOperator)) ||
      (approvals.length === 3 &&
        approvals.includes(InternalTransferApprovalType.FactualAuditor) &&
        approvals.includes(InternalTransferApprovalType.CommandOperator) &&
        approvals.includes(InternalTransferApprovalType.ChiefAccountant))
    );
  }
}
